<template>
  <a-modal
    title="自有工人信息"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="id" :labelCol="labelCol" :wrapperCol="wrapperCol" v-show="false">
          <a-input :disabled="showable" v-decorator="['id']" />
        </a-form-item>
        <a-form-item
          label="考勤小组"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            showSearch
            :disabled="showable"
            placeholder="请选择"
            v-decorator="['groupId', {rules: [{required: true, message: '请选择考勤小组'}]}]"
            :options="attendGroupList"
            optionFilterProp="children"
          >
          </a-select>
        </a-form-item>
        <a-form-item
          label="工人类别"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            showSearch
            :disabled="showable"
            placeholder="请选择"
            v-decorator="['typeId', {rules: [{required: true, message: '请选择工人类别'}]}]"
            :options="sxWorkerTypeList"
            optionFilterProp="children"
          >
          </a-select>
        </a-form-item>
        <a-form-item
          label="人数"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input-number
            :precision="0.1"
            style="width: 100%"
            :min="0"
            :disabled="showable"
            placeholder="请输入"
            v-decorator="['number', {rules: [{required: true, message: '请输入人数(正整数)'}]}]" />
        </a-form-item>
        <a-form-item
          label="工时"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input-number
            :precision="2"
            style="width: 100%"
            :min="0"
            :disabled="showable"
            placeholder="请输入"
            v-decorator="['workHour', {rules: [{required: true, message: '请输入工时(最多输入两位小数)'}]}]" />
        </a-form-item>
        <a-form-item
          label="工作内容及工作量"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            :disabled="showable"
            placeholder="请输入"
            v-decorator="['content', {rules: [{required: true, message: '请输入工作内容及工作量'}]}]"
          />
        </a-form-item>
        <a-form-item
          label="备注"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            :disabled="showable"
            placeholder="请输入"
            v-decorator="['remark']"
          />
        </a-form-item>
      </a-form>
    </a-spin>
    <template slot="footer">
      <div>
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="confirmLoading" type="primary" @click="handleOk">保存</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { dropAttendGroupListByProjectId } from '@/api/common/AttendGroup'
import { dropSxWorkerTypeList } from '@/api/common/SxWorkerType'
export default {
  name: 'DailyWorkAdd',
  components: {},
  props: {
    projectId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      attendGroupList: [],
      sxWorkerTypeList: [],
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      editable: false,
      addable: false,
      theKey: 0,
      showable: false
    }
  },
  methods: {
    // 获取用户消息
    edit (child, type) {
      this.visible = true
      // dropAttendGroupListByProjectId().then(res => {
      //   this.attendGroupList = res.data
      // })
      dropSxWorkerTypeList().then(res => {
        this.sxWorkerTypeList = res.data
      })
      if (type === 'edit') {
        this.type = type
        this.theKey = child.key
      }
      if (type && type === 'add') {
        this.type = type
      }
      const {
        form: { setFieldsValue, resetFields }
      } = this
      if (type === 'add') {
        resetFields()
      } else if (type === 'edit') {
        const pickFiled = [
          'id',
          'groupId',
          'typeId',
          'number',
          'workHour',
          'totalHour',
          'content',
          'remark'
        ]
        this.$nextTick(() => {
          setFieldsValue(pick(child, pickFiled))
        })
      }
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 结束保存用户信息
    handleOk () {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          values.totalHour = (values.number * values.workHour).toFixed(2)
          if (this.type === 'add') {
            this.$emit('changeData', values)
          } else if (this.type === 'edit') {
            values.key = this.theKey
            this.$emit('editData', values)
          }
          this.visible = false
        }
      })
    },
    handleCancel () {
      this.visible = false
      setTimeout(() => {
        this.addable = false
        this.showable = false
        this.editable = false
      }, 200)
    }
  },
  watch: {
    projectId (val) {
      dropAttendGroupListByProjectId(val).then(res => {
        this.attendGroupList = res.data
      })
    }
  }
}
</script>

<style scoped>

</style>
